import {
  Dashboard,
  Business,
  Assignment,
  Settings,
  VolunteerActivism,
  Schedule,
  WorkHistory,
  Info,
  ContactSupport,
  Group,
  Event,
  Handshake,
} from '@mui/icons-material';

export interface NavigationItem {
  title: string;
  path: string;
  icon?: React.ComponentType<any>;
  children?: NavigationItem[];
  isExternal?: boolean;
}

export const publicNavigation: NavigationItem[] = [
  {
    title: 'Surveys',
    path: '/survey',
    icon: VolunteerActivism,
    children: [
      {
        title: 'Volunteer Hours Survey',
        path: 'https://forms.office.com/Pages/ResponsePage.aspx?id=1UyidmZTD0G5biKO7Z36GAOSoJX_EnNJkEbIKU7xRVxUMkNFN0o4MUc4MlkxVkVWSlgwMzhZRlVVRSQlQCN0PWcu',
        icon: VolunteerActivism,
        isExternal: true
      },
      {
        title: 'Educator Survey',
        path: 'https://forms.office.com/Pages/ResponsePage.aspx?id=1UyidmZTD0G5biKO7Z36GAOSoJX_EnNJkEbIKU7xRVxUOVRYRkU2QzM1MVBJUFo2NEpPT1M2Wk9MNSQlQCN0PWcu',
        icon: Handshake,
        isExternal: true
      },
      {
        title: 'Employer Survey',
        path: 'https://forms.office.com/Pages/ResponsePage.aspx?id=1UyidmZTD0G5biKO7Z36GAOSoJX_EnNJkEbIKU7xRVxUMFJaVDZYQ09XQU5KQVpIWklQN0hWQUxORCQlQCN0PWcu',
        icon: Event,
        isExternal: true
      },
    ],
  },
  {
    title: 'About',
    path: '/about-us',
    icon: Info,
    children: [
      {
        title: 'Mission and Values',
        path: '/about',
        icon: Info,
      },
      {
        title: 'The Team',
        path: '/team',
        icon: Group,
      },
    ],
  },
  {
    title: 'How it works',
    path: '/how-it-works/',
    icon: Info
  },
  {
    title: 'Partnerships',
    path: '/partnerships',
    icon: Handshake
  },
  {
    title: 'Contact',
    path: '/contact',
    icon: ContactSupport,
  },
];

export const authenticatedNavigation: Record<string, NavigationItem[]> = {
  student: [
    {
      title: 'Dashboard',
      path: '/student',
      icon: Dashboard,
    },
    {
      title: 'Opportunities',
      path: '/student/opportunities',
      icon: VolunteerActivism,
    },
    {
      title: 'My Applications',
      path: '/student/applications',
      icon: Assignment,
    },
    {
      title: 'Volunteer Hours',
      path: '/student/hours',
      icon: Schedule,
    },
  ],
  teacher: [
    {
      title: 'Dashboard',
      path: '/teacher',
      icon: Dashboard,
    },
    {
      title: 'Settings',
      path: '/teacher/settings',
      icon: Settings,
    },
  ],
  organization: [
    {
      title: 'Dashboard',
      path: '/employer',
      icon: Dashboard,
    },
    {
      title: 'Opportunities',
      path: '/employer/opportunities',
      icon: Business,
    },
    {
      title: 'Applications',
      path: '/employer/applications',
      icon: Assignment,
    },
    {
      title: 'Student Records',
      path: '/employer/records',
      icon: WorkHistory,
    },
    {
      title: 'Settings',
      path: '/employer/settings',
      icon: Settings,
    },
  ],
};